import { c as conversions$1 } from "./conversions.js";
import { r as route$1 } from "./route.js";
const conversions = conversions$1, route = route$1, convert = {}, models = Object.keys(conversions);
function wrapRaw(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    return arg0 == null ? arg0 : (arg0.length > 1 && (args = arg0), fn(args));
  };
  return "conversion" in fn && (wrappedFn.conversion = fn.conversion), wrappedFn;
}
function wrapRounded(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 == null)
      return arg0;
    arg0.length > 1 && (args = arg0);
    const result = fn(args);
    if (typeof result == "object")
      for (let len = result.length, i = 0; i < len; i++)
        result[i] = Math.round(result[i]);
    return result;
  };
  return "conversion" in fn && (wrappedFn.conversion = fn.conversion), wrappedFn;
}
models.forEach((fromModel) => {
  convert[fromModel] = {}, Object.defineProperty(convert[fromModel], "channels", { value: conversions[fromModel].channels }), Object.defineProperty(convert[fromModel], "labels", { value: conversions[fromModel].labels });
  const routes = route(fromModel);
  Object.keys(routes).forEach((toModel) => {
    const fn = routes[toModel];
    convert[fromModel][toModel] = wrapRounded(fn), convert[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert;
export {
  colorConvert as c
};
//# sourceMappingURL=index.js.map
